import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import { ANNUAL, MONTHLY } from '../../constans';
import { formatMoney } from '../../utils/Formatter';
import { addDaysToDate } from '../../utils/Date';
import { useSessionCheck } from '../../hooks/useSessionCheck';
import { t } from 'i18next';


export default function RegistrationComplete() {
  useSessionCheck()
  const plan = sessionStorage.getItem("plan");
  const planData = [{ title: MONTHLY, value: 4.99 }, { title: ANNUAL, value: 49 }]
  const navigate = useNavigate();

  const handleNext = () => {
    window.location.href = "eyeary://Login"
  };

  function getPlanData() {
    return planData.filter((data) => data.title == plan)[0]
  }

  function trans(key){
    return t("onb-web_paymentcompleted_"+key)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={style.scrollContainer}>
        <div className='title title_m_24_medium'>{trans(114)}</div>
        <p className={"description body_15_regular mt-16"}>
          {trans(115)}
        </p>
        {/* <div style={style.card} className='mt-32'>
          <div style={style.cardTitle}>멤버십 요약</div>
          <Row label={"플랜"} value={"30일 Free Trial(Performance Mode)"} />
          <Row label={"결제 금액"} value={formatMoney(getPlanData().value, 2) + (plan == ANNUAL ? " / year" : " / month")} />
          <Row label={"첫 결제일"} value={ addDaysToDate(new Date(), 30).toLocaleDateString()} />
        </div> */}
      </div>
      <div className="button-wrapper">
        <Button
          text={t("completion_page_168")}
          onClick={handleNext}
          className={"primary-on-button primary-button-text"}
        />
      </div>

    </ScreenContainer>

  );
}
const Row = ({ label, value }) => {
  return <div style={style.row}>
    <div className='body_14_regular' style={{ color: colors.mono300 }}>{label}: </div>
    <div className='body_14_regular'>{value}</div>
  </div>
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll'
  },
  card: {
    backgroundColor: '#111D22',
    borderRadius: 20,
    padding: 20,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
    width: '100%',
    borderBottom: '1px solid #23292E',
    paddingBottom: 8

  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }

}